const CACHE_VERSION = 'v1';
export const CLIENTS_CACHE_KEY = `admin.clients.${CACHE_VERSION}`;
export const COURSES_CACHE_KEY = `admin.courses.${CACHE_VERSION}`;
export const TTL_MS = 3 * 60 * 1000;

export function readCache(key) {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    const age = Date.now() - (parsed.savedAt || 0);
    if (age > TTL_MS) return null;
    return parsed.data || null;
  } catch {
    return null;
  }
}

export function writeCache(key, data) {
  try {
    localStorage.setItem(key, JSON.stringify({ savedAt: Date.now(), data }));
  } catch {}
}

export function invalidateAdminCache() {
  try {
    localStorage.removeItem(CLIENTS_CACHE_KEY);
    localStorage.removeItem(COURSES_CACHE_KEY);
  } catch {}
}
